import { ToolCallProps } from "@/taskpane/types/ToolCall";
import { LegalDocumentsResult } from "../ToolResults/LegalDocumentsResult";
import { Document } from "@/taskpane/types/Document";
import { X } from "lucide-react";

type RetrieveLegalDocsToolProps = ToolCallProps<
	{
		query: string;
		k: number;
	},
	Document[] | string
>;

export function RetrieveLegalDocsTool({ args, result, status }: RetrieveLegalDocsToolProps) {
	if (status === 'loading') {
		const message = args?.["query"] ? `Recherche: ${args?.["query"]}` : "Recherche de sources...";
		return (
			<div className='flex items-center gap-2 text-sm text-base-content/50 italic'>
				<span className='loading loading-spinner loading-xs' />
				<span>{message}</span>
			</div>
		);
	}

	if (status === 'error') {
		return (
			<div className='flex items-center gap-2 text-sm text-base-content/50 italic'>
				<X className='w-4 h-4' />
				<span>Echec de la recherche</span>
			</div>
		);
	}

	let documents: Document[] = [];
	if (typeof result === 'string') {
		documents = JSON.parse(result) as Document[];
	} else if (Array.isArray(result)) {
		documents = result;
	} else {
		documents = [];
	}

	return <LegalDocumentsResult documents={documents} />;
}
